<template>
  <div class="setting-share-modal">
    <div class="modal-close" @click="$emit('close', 'close')">
      <i class="icon icon--close-size16"></i>
    </div>
    <div class="share-modal-header">
      <i class="icon icon--share-domain-master size-20"></i>
      <div class="share-title">{{ $t('share.setting') }}</div>
      <div class="domain-url">*.{{ domain.domain }}</div>
    </div>
    <div class="share-tab-buttons">
      <div class="tab-item tab-1" :class="{select: selectedMode === 'share'}" @click="toggleShareMode('share')">{{ $t('share.reportShare') }}</div>
      <div class="tab-item tab-2" :class="{select: selectedMode === 'manage'}" @click="toggleShareMode('manage')">{{ $t('share.manageShare') }}</div>
    </div>
    <div class="share-modal-contents">
      <template v-if="selectedMode === 'share'">
        <div class="share-step-title">
          <div class="step-number">
            {{ shareStep }}
          </div>
          <div class="share-step-text" v-html="$t(`share.shareContents.step${shareStep}`)"></div>
        </div>
        <div class="step-contents-wrapper slide-contents" :class="`current-${shareStep}`">
          <div class="step-contents step-1">
            <StepDataList :domains="domainList" @update="setSharedDomains"/>
          </div>
          <div class="step-contents step-2">
            <div class="insert-share-user-wrapper">
              <div class="input-wrapper" :class="{error: errorType}" >
                <input type="text" v-model="insertedUser" placeholder="beusable ID" @input="insertingText" @keydown.enter="checkShareUser()">
                <div v-if="errorType" class="error-message">
                  <template v-if="errorType === 'Invalid user'">{{ $t('share.shareUser.errorText.invalid') }}</template>
                  <template v-if="errorType === 'Already shared'">{{ $t('share.shareUser.errorText.already') }}</template>
                  <template v-if="errorType === 'Duplicate user'">{{ $t('share.shareUser.errorText.duplicate') }}</template>
                  <template v-if="errorType === 'Self shared'">{{ $t('share.shareUser.errorText.userSelf') }}</template>
                </div>
                <span v-if="errorType" class="reset-data" @click="insertedUser = ''; errorType = null">
                  <i class="icon icon--close14"></i>
                </span>
              </div>
              <div class="btf-button outline primary" :disabled="!!errorType || insertedUser === ''" @click="checkShareUser()">
                {{ $t('common.confirm') }}
              </div>
            </div>
            <div v-if="shareUserList.length > 0" class="shared-users-list-wrapper list-vignetting">
              <div class="shared-users-list">
                <div class="shared-user-item chip" v-for="user in shareUserList" :key="user.userNum" :class="{duplicate: user.userId === insertedUser}">
                  <div class="user-email">{{ user.userId }}</div>
                  <i class="icon icon--close14" @click="removeShareUser(user)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="share-step-footer">
          <template v-if="shareStep === 1">
            <div class="btf-button outline icon primary" :disabled="noShareData" @click="shareStep = 2">
              {{ $t('common.next') }}
              <i class="icon icon--arrow-right-red"></i>
            </div>
          </template>
          <template v-else>
            <div class="prev-btn btf-button text icon" @click="prevShareStep">
              <i class="icon icon--arrow-left-gray"></i>
              {{ $t('common.prev') }}
            </div>
            <div class="btf-button primary center" :disabled="shareUserList.length < 1" @click="setSharedUserDomain()">
              {{ $t('common.share') }}
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <template v-if="sharedUserData.length === 0">
          <div class="no-shared-wrapper">
            <i class="img-no-shared"></i>
            <div class="no-shared-text">
              {{ $t('share.noShareUser') }}
            </div>
          </div>
        </template>
        <template v-else >
          <div class="share-manage-title">
            <div v-if="manageStep === 2" class="prev-btn user-id" @click="manageStep = 1">
              <i class="icon icon--arrow-left-black"></i>
              {{ selectedUser.userId }}
            </div>
          </div>
          <div class="manage-contents-wrapper slide-contents" :class="`current-${manageStep}`">
            <div class="manage-contents step-contents user-list step-1">
              <div class="btf-data-table">
                <div class="data-table-header">
                  <div class="data-table-header-column" v-for="(col, i) in shareManageTable" :key="col.name">
                    <div class="col-name">{{ $t(`share.shareManage.userTableColumn.${col.name}`) }}</div>
                    <div class="col-count-badge">{{ col.count | thousand }}</div>
                    <div class="sort-btn" :class="col.sort" @click="sortColumn(i)">
                      <i v-if="!col.sort" class="icon icon--sort-black"></i>
                      <i v-else class="icon icon--sort-black-asc"></i>
                      <!-- <i class="icon icon--sort-black-desc"></i> -->
                    </div>
                  </div>
                  <div class="data-table-header-column"></div>
                </div>
                <div class="data-table-body">
                  <div class="data-table-row" v-for="(shared, i) in sharedUserDataList" :key="`shared-${i}`">
                    <div class="data-table-column user-id" @click="selectDeleteUser(shared)">
                      <div class="checkbox-wrap">
                          <div class="checkbox" :class="{ on: deleteUserList.some(item => item === shared.userId )}"></div>
                        </div>
                      <div class="colum-text ellipsis">{{ shared.userId }}</div>
                    </div>
                    <div class="data-table-column  domain">
                      <div class="colum-text ellipsis">{{ shared.domain === 1 ? shared.domainText : $t('share.shareManage.selectedCount', {num: shared.domain}) }}</div>
                    </div>
                    <div class="data-table-column first-path">
                      <template v-if="shared.firstPath > 1">
                        <div class="column-text">{{ $t('share.shareManage.selectedCount', {num: shared.firstPath})}}</div>
                      </template>
                      <template v-else-if="shared.firstPath === 1">
                        <div class="column-text ellipsis">
                          {{ shared.domain > 1 ? $t('share.shareManage.selectedCount', {num: 1 }) : shared.pathText === "" ? "/" : `/${shared.pathText}/`}}
                        </div>
                      </template>
                      <template v-else>-</template>
                    </div>
                    <div class="step-button" @click="setDetail(shared, i)">
                      <i class="icon icon--arrow-body-right-gray size-20"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="manageStep === 2" class="manage-contents step-contents user-list step-2">
              <StepDataList :domains="domainList" :selected-list="selectedUser.domain" @update="setEditedDomains" />
            </div>
          </div>
          <div class="share-step-footer">
            <template v-if="manageStep === 1">
              <div class="btf-button primary" :disabled="deleteUserList.length === 0" @click="confirmDelete()">
                {{ $t('share.shareManage.disabledShare') }}
              </div>
            </template>
            <template v-else>
              <div class="btf-button primary" :disabled="Object.keys(editedDomains).length === 0" @click="updateSharedUserDomain()">
                {{ $t('common.edit') }}
              </div>
            </template>
          </div>
        </template>
      </template>
    </div>
    <div v-if="openAlert" class="alert-confirm alert-container">
      <div class="alert-icon">
        <i class="icon icon--dialog-warning"></i>
      </div>
      <div class="alert-title" v-html=" $t('share.dialogText.confirm.title')"></div>
      <div class="alert-description" v-html=" $t('share.dialogText.confirm.description', { count: deleteUserList.length })"></div>
      <div class="alert-btn">
        <div class="btf-button outline" @click="openAlert = null" >{{ $t('common.cancel') }}</div>
        <div class="btf-button outline primary" @click="deleteSharedUserDomain()">{{ $t('share.dialogText.removeShare') }}</div>
      </div>
    </div>
    <div v-if="showToast" class="toast-message">
      <div class="toast-text">{{ $t(`share.toastMessage.${showToast}.text`) }}</div>
      <i class="icon icon--check-green size-16"></i>
    </div>
  </div>
</template>
<script>
import StepDataList from '@/components/dashboard/StepDataList.vue'
import {
  getPathData,
  addSharedUser,
  getSharedUsers,
  setSharedDomain,
  deleteSharedUser,
  updateSharedUser,
  getSelectedUserData
} from '@/api/domain'

const TABLE_COLUMNS = [
  { name: 'userId', sort: 'asc', count: 0 },
  { name: 'domain', sort: null, count: 0 },
  { name: 'firstPath', sort: null, count: 0 }
]

export default {
  name: 'SettingShare',
  components: { StepDataList },
  props: {
    pid: {
      type: String,
      require: true
    },
    domain: {
      type: Object,
      require: true
    },
    userId: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      selectedMode: 'share',
      shareStep: 1,
      manageStep: 1,
      domainList: [],
      selectedDomain: null,
      shareUserList: [],
      sharedUserData: {},
      insertedUser: '',
      errorType: null,
      shareManageTable: TABLE_COLUMNS,
      sharedUserDataList: [],
      selectedUser: {},
      sharedDomains: {},
      deleteUserList: [],
      editedDomains: {},
      openAlert: null,
      showToast: false
    }
  },
  computed: {
    noShareData () {
      return this.domainList.every(item => !item.isShare)
    }
  },
  created () {
    // this.deleteSharedUserDomain()
    this.getPathList()
    this.getSharedUserList()
  },
  methods: {
    toggleShareMode (mode) {
      if (mode === 'share') {
        this.prevShareStep()
        this.getPathList()
      } else {
        this.manageStep = 1
      }
      this.selectedMode = mode
    },
    getPathList () {
      const requestData = {
        parentSid: this.domain.parentSid
      }
      getPathData(requestData).then(res => {
        this.domainList = res.map(item => {
          this.$set(item, 'isShare', true)
          return item
        })
      })
    },
    getSharedUserList () {
      const requestData = {
        parentSid: this.domain.parentSid
      }
      getSharedUsers(requestData).then(res => {
        this.sharedUserData = res
        this.setDataList(res)
        this.countUserData(res)
      })
    },
    setSharedUserDomain () {
      const requestData = {
        parentSid: this.domain.parentSid,
        users: this.shareUserList.map(user => { return { userId: user.userId, userNum: user.userNum } }),
        sids: this.sharedDomains
      }
      setSharedDomain(requestData).then(res => {
        // this.getSharedUserList()
        this.$emit('close', 'success')
      })
    },
    confirmDelete (value) {
      this.openAlert = true
    },
    deleteSharedUserDomain () {
      this.openAlert = null
      const requestData = {
        parentSid: this.domain.parentSid,
        userIds: this.deleteUserList
      }
      deleteSharedUser(requestData).then(res => {
        this.getSharedUserList()
        this.showToastInterval('delete')
      })
    },
    updateSharedUserDomain () {
      const requestData = {
        parentSid: this.domain.parentSid,
        userId: this.selectedUser.userId,
        userNum: this.selectedUser.userNum,
        share: this.editedDomains
      }
      updateSharedUser(requestData).then(res => {
        console.log(res)
        this.getSharedUserList()
        this.showToastInterval('complete')
        this.editedDomains = {}
      })
    },
    checkShareUser () {
      if (this.checkDuplicateUser()) {
        this.errorType = 'Duplicate user'
        return
      }
      if (this.checkSharedSelf()) {
        this.errorType = 'Invalid user'
        return
      }
      const requestData = {
        parentSid: this.domain.parentSid,
        userId: this.insertedUser
      }

      addSharedUser(requestData).then(res => {
        this.shareUserList.push(res)
        this.insertedUser = ''
      }).catch(err => {
        console.log('error:', err.message)
        this.errorType = err.message
      })
    },
    removeShareUser (user) {
      const removeUser = this.shareUserList.findIndex(item => item.userNum === user.userNum)
      this.shareUserList.splice(removeUser, 1)
    },
    selectDomain (domain) {
      this.selectedDomain = domain
    },
    insertingText () {
      if (this.errorType) this.errorType = null
    },
    checkDuplicateUser () {
      return this.shareUserList.some(item => item.userId === this.insertedUser)
    },
    checkSharedSelf () {
      // const shareId = this.insertedUser.slice(0, this.insertedUser.indexOf('@'))
      return this.userId === this.insertedUser
    },
    setToggleDomain () {
      if (this.domainListState === 'set') return false
      const state = this.domainListState === 'on'
      this.domainList.map(item => { item.isShare = !state })
    },
    toggleFirstPath (path, i) {
      let domain = this.sharedDomains[this.selectedDomain.sid]
      const idx = domain.findIndex(item => item === path)
      idx > -1 ? domain.splice(idx, 1) : domain.splice(idx, 0, path)
      this.sharedDomains[this.selectedDomain.sid] = domain
    },
    setDetail (sharedData, idx) {
      const requestData = {
        parentSid: this.domain.parentSid,
        userId: this.sharedUserData[idx].userId,
        userNum: this.sharedUserData[idx].userNum
      }
      getSelectedUserData(requestData).then(res => {
        this.selectedUser = res
        this.manageStep = 2
      })

    },
    setSharedDomains (value) {
      this.sharedDomains = {}
      this.domainList.forEach(domain => {
        if (domain.isShare) {
          this.sharedDomains[domain.sid] = value[domain.sid]
        }
      })
    },
    setEditedDomains (value) {
      this.editedDomains = {}
      this.domainList.forEach(domain => {
        if (domain.isShare) {
          this.editedDomains[domain.sid] = value[domain.sid]
        }
      })
    },
    countUserData (data) {
      this.shareManageTable[0].count = data.length
      this.shareManageTable[1].count = data.reduce((t, c) => { return t + c.domainCount }, 0)
      let total = 0
      this.shareManageTable[2].count = data.reduce((t, c) => { return t + c.pathCount }, 0)
    },
    selectDeleteUser (user) {
      const idx = this.deleteUserList.findIndex(c => c === user.userId)

      idx > -1 ? this.deleteUserList.splice(idx, 1) : this.deleteUserList.push(user.userId)
    },
    showToastInterval (type) {
      this.showToast = type
      setTimeout(() => {
        this.showToast = null
      }, 3000)
    },
    prevShareStep () {
      this.shareStep = 1
      this.insertedUser = ''
      this.errorType = null
    },
    setDataList (data) {
      this.shareManageTable.map(col => { col.name === 'userId' ? col.sort = 'asc' : col.sort = null })
      this.sharedUserDataList = data.map(domain => {
        return {
          userId: domain.userId,
          userNum: domain.userNum,
          // domain: Object.keys(domain.domain).length,
          // domainText: Object.keys(domain.domain)[0],
          // firstPath: Object.keys(domain.domain).reduce((t, a) => { return t + domain.domain[a].length }, 0),
          // pathText: Object.keys(domain.domain).reduce((t, a) => { return [...t, ...domain.domain[a]] }, [])[0]
          domain: domain.domainCount,
          firstPath: domain.pathCount,
        }
      })
    },
    sortColumn (col) {
      let sortType = this.shareManageTable[col].name
      this.shareManageTable.map(item => {
        if (item.name === sortType) {
          item.sort = !item.sort ? 'asc' : item.sort === 'asc' ? 'desc' : 'asc'
          this.sortUserListByType(sortType, item.sort)
        } else {
          item.sort = null
        }
        return item
      })
    },
    sortUserListByType (type, sort) {
      this.sharedUserDataList.sort((a, b) => {
        if (sort === 'asc') {
          return a[type] < b[type] ? -1 : a[type] > b[type] ? 1 : 0
        } else {
          return b[type] < a[type] ? -1 : b[type] > a[type] ? 1 : 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-share-modal {
  position: relative;
  width: 960px;
  min-height: 612px;
  background-color: #fff;
  border-radius: 14px;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.16), 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
  padding: 25px;
  box-sizing: border-box;
  .modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  .share-modal-header {
    display: flex;
    align-items: center;
    gap: 10px;
    .share-title {
      font-size: 15px;
      font-weight: 500;
      color: #2f2f2f;
    }
    .domain-url {
      color: #767676;
      font-size: 12px;
      font-weight: 400;
      &:before {
        content: '';
        border-left: 1px solid #D7D7D7;
        padding-right: 10px;
      }
    }
  }
  .share-tab-buttons {
    display: flex;
    border: 1px solid #E0E0E0;
    width: 470px;
    height: 38px;
    border-radius: 20px;
    margin: 25px 0;
    .tab-item {
      cursor: pointer;
      color: #888;
      font-size: 15px;
      font-weight: 500;
      text-align: center;
      padding: 12px;
      width: 50%;
      border-radius: 20px;
      line-height: 1;
      &.select {
        color: #fff;
        background-color: $brandColor;
        border: 1px solid $brandColor;
        margin: -1px;
        box-shadow: 0px 12px 10px -4px rgba(0, 0, 0, 0.20);
      }
    }
  }
  .share-modal-contents {
    overflow: hidden;
    .share-step-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 30px;
      .step-number {
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid #d7d7d7;
        line-height: 1;
        padding: 7px;
        box-sizing: border-box;
      }
      .share-step-text {
        line-height: 1;
        color: #2f2f2f;
      }
    }
    .slide-contents {
      display: flex;
      transition: transform 250ms ease;
      transform: translateX(0);
      > div {
        width: 100%;
        flex-shrink: 0;
      }
      &.current-2 {
        transform: translateX(calc(-100% - 5px));
      }
    }
    .step-contents-wrapper {
      position: relative;
      margin-bottom: 13px;
      .step-contents {
        width: 100%;
        flex-shrink: 0;
        &.step-2 {
          margin-left: 5px;
          .insert-share-user-wrapper {

            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
            margin-bottom: 30px;
            color: #444;
            .input-wrapper {
              position: relative;
              width: 480px;
              height: 38px;
              border-radius: 6px;
              border: 1px solid #bbb;
              display: flex;
              align-items: center;
              padding: 9px 12px;
              font-size: 14px;
              box-sizing: border-box;
              input {
                flex-grow: 1;

                border: 0;
              }
              .error-message {
                position: absolute;
                top: 100%;
                left : 0;
                margin-top: 4px;
                color: #E60724;
                font-size: 12px;
                font-weight: 500;
                line-height: 1;
              }
              .reset-data {
                padding: 12px;
              }
              &.error {
                border-color: #E60724;
              }
            }
          }
          .shared-users-list-wrapper {
            border-top: 1px solid #E1E1E1;
          }
          .shared-users-list {
            display: flex;
            justify-content: center;
            gap: 8px;
            flex-wrap: wrap;
            padding: 30px 20px;
            max-height: calc(43px * 5);
            overflow-y: auto;
            box-sizing: border-box;
            .shared-user-item {
              display: inline-flex;
              align-items: center;
              gap: 10px;
              padding: 12px;
              border-radius: 6px;
              border: 1px solid #BBB;
              background-color: #FFF;
              &.duplicate {
                border-color: #E60724;
              }
            }
          }
        }
      }
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 30px;
        bottom: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 35.94%, rgba(255, 255, 255, 0.96) 61.46%, #FFF 100%);
      }
    }
    .share-step-footer {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .prev-btn {
        position: absolute;
        top: 50%;
        left: -14px;
        transform: translateY(-50%);
      }
    }
    .share-manage-title {
      position: absolute;
      margin-bottom: 30px;
      z-index: 1;
      .user-id {
        padding: 7px 0;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        color: #2F2F2F;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
      }
    }
    .manage-contents-wrapper {

      .manage-contents {
        margin-bottom: 13px;
        &.step-1 {
        padding-top: 30px;
      }
        &.step-2 {
          padding-top: 60px;
        }
      }
    }
    .no-shared-wrapper {
      width: 100%;
      height: 450px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 32px;

      color: #767676;
      font-size: 14px;
      .img-no-shared {
        display: inline-block;
        width: 130px;
        height: 103px;
        background-image: url('../../assets/img/dashboard/img--no-shared.svg');
      }
    }
  }
}
.checkbox-wrap {
  .checkbox {
    cursor: pointer;
    width : 16px;
    height: 16px;
    margin: 1px;
    border: 2px solid #aaa;
    border-radius: 2px;
    background-color: #fff;
    box-sizing: border-box;
    &.on {
      border: 0;
      background: url('../../assets/img/common/icon--check-white-size14.svg') center center no-repeat $brandColor;
    }
    &.set {
      border: 0;
      background: url('../../assets/img/icon_chkbox_on_unselect.svg') center center no-repeat $brandColor;
    }
  }
}

.btf-data-table {
  position: relative;
  width: 100%;
  font-size: 13px;
  color: #666;
  box-sizing: border-box;
  margin-bottom: 25px;
  * {box-sizing: border-box;}
  .data-table-header {
    display: flex;
    flex: 1 0 auto;
    border-bottom:1px solid #bbb;
    color: #444;
    .data-table-header-column {
      min-width: calc(100% / 3);
      padding: 12px 15px;
      display: flex;
      gap: 5px;
      align-items: center;
      .col-count-badge {
        display: inline-block;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.30);
        background-color: #fff;
        font-size: 12px;
        color: #444;
        padding: 3px 6px;
        font-weight: 500;
        line-height: 1;
      }
      .sort-btn {
        display: flex;
        flex-direction: column;
        &.asc {
          opacity: 1;
        }
        &.desc {
          opacity: 1;
          transform: rotate(180deg);
        }
      }
    }
  }
  .data-table-body {
    position: relative;
    height: calc(43px * 7);
    padding-bottom: 25px;
    overflow-y: auto;
    .data-table-row {
      position: relative;
      display: flex;
      flex: 1 0 auto;
      border-bottom: 1px solid #ebebeb;
      .data-table-column {
        width: calc(100% / 3);
        padding: 12px 15px;
        display: flex;
        align-items: center;
        .column-text {
          width: 100%;
          line-height: 1;
        }
        &.user-id {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        &.first-path {
          // .column-text:first-letter {
          //   text-transform: uppercase;
          // }
        }
      }
      .step-button {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(-10px, -50%);
        padding: 6px;
        border-radius: 5px;
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
        &:hover {
          background-color: rgba(0, 0, 0, 0.06);
        }
      }
    }
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 35.94%, rgba(255, 255, 255, 0.96) 61.46%, #FFF 100%);
  }
}
.alert-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 14px;
  background: #FFF;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
  padding: 50px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  gap: 12px;
  width: 330px;
  min-height: 238px;
  .alert-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.alert-confirm {

  color: #2F2F2F;

  font-size: 14px;
  line-height: 1.5;
  .alert-title {
    color: #444;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
  .alert-description {
    text-align: center;
    padding-bottom: 45px;
  }
  .alert-btn {
    position: absolute;
    bottom: 0;
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.toast-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  background: #000;

  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
  padding: 8px 10px;
  display: inline-flex;
  align-items: center;
  gap: 20px;
  color: #57AB00;

  font-size: 13px;
  font-weight: 400;
  line-height: 1;
}

</style>
